<mat-toolbar>
  <div class="fxf-auto-fill-r fxl-row fxla-center-center fxla-space-between-center_gt-xs">
    <a
      class="pink fxf-0-0-auto-r fxl-row fxla-start-center"
      href="https://1.envato.market/c/1257954/275988/4415?u=https%3A%2F%2Fthemeforest.net%2Fitem%2Ffuse-angularjs-material-design-admin-template%2F12931855"
      mat-button
      target="_blank"
    >
      <mat-icon class="s-16 mr-sm-4">shopping_cart</mat-icon>
      <span>Purchase FUSE (Angular 7+)</span>
    </a>

    <div class="fx-hide fxl-row fxla-start-center fx-show-flex_gt-xs">
      <a mat-button routerLink="/documentation/getting-started/introduction">Documentation</a>
      <span>&bull;</span>
      <a mat-button routerLink="/documentation/changelog">Changelog</a>
    </div>
  </div>
</mat-toolbar>
